import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface MasterDataClientModel {
  id?: string;
  documentId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  document?: string;
  phone?: string;
  approved?: boolean;
  isNewsletterOptIn?: boolean;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class MasterDataService {
  private readonly baseUrl = `${environment.backend.url}/api/vtex/masterdata/v1`;

  constructor(private readonly http: HttpClient) {}

  getClientByEmail(email: string): Observable<MasterDataClientModel[]> {
    const params = new HttpParams().set('email', email.trim());

    return this.http.get<MasterDataClientModel[]>(
      `${this.baseUrl}/clByEmail`,
      { params }
    );
  }

  updateClientField(
    documentId: string,
    payload: Partial<MasterDataClientModel>
  ): Observable<void> {
    return this.http.patch<void>(
      `${this.baseUrl}/cl/${documentId}`,
      payload
    );
  }
}